export var count = function () { return function (pageViews) { return pageViews.length; }; };
//# sourceMappingURL=reducers.js.map